import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../css/others/Table.css";
import { apiCall } from "../main/ApiCall";
import { MeetingTrackerDetailsInfoResponse } from "../interFaces/interfaces"
import BackButton from "../Reusablecomponents/BackButton";
const FunctionMeetingTrackerDetailsInfo: React.FC = () => {
    const { campaignId, functionId } = useParams<{ campaignId: string; functionId: string; }>();
    const clientId = localStorage.getItem("clientId");
    const [data, setData] = useState<MeetingTrackerDetailsInfoResponse | null>(null);
    const [loading, setLoading] = useState(false);
    const fetchDetailsInfo = useCallback(async () => {
        if (!campaignId || !functionId) return;
        setLoading(true);
        try {
            const response = await apiCall("get", `/api/function-meeting-tracking/${clientId}/${campaignId}/${functionId}`);
            setData(response);
        } catch (error) {
            console.error("Failed to fetch meeting tracker details info", error);
        } finally {
            setLoading(false);
        }
    }, [clientId, campaignId, functionId]);
    useEffect(() => {
        fetchDetailsInfo();
    }, [fetchDetailsInfo]);
    return (
        <div className="table-details">
            <div className="table-title">
                <h2>Function Meeting Tracker Function Details</h2>
            </div>
            <div className="table-container">
                <div className="table-inner-container">
                    <table className="main-table">
                        <thead>
                            <tr>
                                <th>Email</th>
                                <th>Role</th>
                                <th>Status</th>
                                <th>Response Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan={4} className="no-data">Loading..</td>
                                </tr>
                            ) : data?.detailedResponses?.length ? (
                                data.detailedResponses.map((res, index) => (
                                    <tr key={index}>
                                        <td>{res.email}</td>
                                        <td>{res.role}</td>
                                        <td><span className={`status ${res.responseStatus.toLowerCase()}`}>{res.responseStatus}</span></td>
                                        <td>{new Date(res.responseTime).toLocaleString()}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={4} className="no-data">No response data found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="buttons">
                <BackButton className="back-button2" label="Back" />
            </div>
        </div>
    );
};
export default FunctionMeetingTrackerDetailsInfo;